import styles from './Requests.module.scss'
import {Button} from 'common/components/V2'

// type ButtonKeyType = 'new' | 'reviewing' | 'declined'
export type ButtonKeyType = 'approved' | 'current' | 'declined'
export interface IButtonProps {
  label: string; key: ButtonKeyType; variant?: 'secondary' | 'grey';
}

export const BUTTONS_PROPS_ALL: IButtonProps[] = [
  { label: 'Requests', key: 'current', },
  { label: 'Approved', key: 'approved', },
  { label: 'Declined', key: 'declined', },
]

export const ButtonOptions = ({ currentBtnKey, buttons, onClick }: {
  currentBtnKey: ButtonKeyType,
  onClick: (key:ButtonKeyType) => void;
  buttons: IButtonProps[]
}) => (
  <div className={styles.buttons}>
  { buttons.map((b:IButtonProps, index:number) => (
    <Button key={index} className='frame'
      $size='small'
      $color={(b.key === currentBtnKey) ? 'yellow':'charcoal'}
      onClick={() => onClick(b.key)}
    >
      {b.label}
    </Button>
  ))}
  </div>
)
